let updatingBar = false; // Prevent overlapping updates

function updateMultiCartBar() {
  if (updatingBar) return;  // Stop double/triple triggering
  updatingBar = true;

  const bar = document.querySelector("#multi-offer-bar");
  if (!bar) {
    updatingBar = false;
    return;
  }

  const text = bar.querySelector(".multi-offer-text");
  const fill = bar.querySelector(".multi-offer-progress-fill");

  if (!fill || !text) {
    updatingBar = false;
    return;
  }

  const MODE = bar.dataset.mode || "item_based";
  const COMPLETE_TEXT = bar.dataset.completeText || "Unlocked: 30% OFF + Free Shipping";
  const PROGRESS_COLOR = bar.dataset.progressColor || "#ff6a00";
  const BG_COLOR = bar.dataset.bgColor || "#e0e0e0";

  // Value-based thresholds (in AED)
  const FREE_SHIPPING = parseFloat(bar.dataset.freeShippingThreshold) || 499;
  const TIER1 = parseFloat(bar.dataset.tier1Threshold) || 599;
  const TIER2 = parseFloat(bar.dataset.tier2Threshold) || 999;
  const TIER3 = parseFloat(bar.dataset.tier3Threshold) || 1499;
  const TIER4 = parseFloat(bar.dataset.tier4Threshold) || 1999;

  bar.style.background = BG_COLOR;
  fill.style.background = PROGRESS_COLOR;
  fill.style.display = "block";

  fetch("/cart.js?ts=" + Date.now()) // Force fresh fetch, no caching
    .then(res => res.json())
    .then(cart => {
      let message = "";
      let progress = 0;

      if (MODE === "value_based") {
        // --- VALUE-BASED DISCOUNT RULES ---
        // Use original_total_price (before discount codes) to check thresholds
        const totalInAED = (cart.original_total_price || cart.items_subtotal_price || 0) / 100;

        if (totalInAED >= TIER4) {
          message = `🎉 Unlocked: <strong>30% OFF</strong> & free shipping!`;
          progress = 100;
        } else if (totalInAED >= TIER3) {
          const remaining = Math.ceil(TIER4 - totalInAED);
          message = `Unlocked: <strong>25% OFF</strong> & free shipping! Add <strong>AED ${remaining}</strong> more to get <strong>30% OFF</strong>`;
          progress = 80;
        } else if (totalInAED >= TIER2) {
          const remaining = Math.ceil(TIER3 - totalInAED);
          message = `Unlocked: <strong>20% OFF</strong> & free shipping! Add <strong>AED ${remaining}</strong> more to get <strong>25% OFF</strong>`;
          progress = 60;
        } else if (totalInAED >= TIER1) {
          const remaining = Math.ceil(TIER2 - totalInAED);
          message = `Unlocked: <strong>15% OFF</strong> & free shipping! Add <strong>AED ${remaining}</strong> more to get <strong>20% OFF</strong>`;
          progress = 40;
        } else if (totalInAED >= FREE_SHIPPING) {
          const remaining = Math.ceil(TIER1 - totalInAED);
          message = `Unlocked: <strong>Free shipping!</strong> Add <strong>AED ${remaining}</strong> more to get <strong>15% OFF</strong>`;
          progress = 20;
        } else if (totalInAED > 0) {
          const remaining = Math.ceil(FREE_SHIPPING - totalInAED);
          message = `Add <strong>AED ${remaining}</strong> more to unlock <strong>free shipping!</strong>`;
          progress = Math.round((totalInAED / FREE_SHIPPING) * 20);
        } else {
          message = "Add items to unlock free shipping & discounts!";
          progress = 0;
        }

      } else {
        // --- ITEM-BASED DISCOUNT RULES (original logic) ---
        const items = cart.item_count || 0;

        switch (items) {
          case 0:
            message = "Add items to unlock discounts & free shipping!";
            progress = 0;
            break;
          case 1:
            message = `To get <strong>20% OFF</strong>, add 1 more item`;
            progress = 25;
            break;
          case 2:
            message = `Unlocked: <strong>20% OFF</strong>. Add 1 more item to get <strong>25% OFF + Free Shipping</strong>`;
            progress = 50;
            break;
          case 3:
            message = `Unlocked: <strong>25% OFF + Free Shipping</strong>. Add 1 more item to get <strong>30% OFF</strong>`;
            progress = 75;
            break;
          default:
            message = COMPLETE_TEXT;
            progress = 100;
            break;
        }
      }

      // Update text instantly (NO flashing "Loading…")
      text.innerHTML = message;

      // Smooth progress update
      requestAnimationFrame(() => {
        fill.style.width = progress + "%";
      });

      updatingBar = false;
    })
    .catch(() => {
      updatingBar = false;
    });
}

// --- EVENT LISTENERS ---

// On page load
document.addEventListener("DOMContentLoaded", updateMultiCartBar);

// When Shopify updates cart (Dawn + apps)
document.addEventListener("cart:updated", updateMultiCartBar);

// Capture Ajax quantity changes (cart drawer with fetch)
document.addEventListener("change", (e) => {
  if (e.target.name === "updates[]") {
    setTimeout(updateMultiCartBar, 150); // Wait for Shopify AJAX to finish
  }
});

// Fallback poll (stable, low load)
setInterval(updateMultiCartBar, 1200);

// Watch for cart drawer opening / re-render
const observer = new MutationObserver(() => {
  if (document.querySelector("#multi-offer-bar")) {
    updateMultiCartBar();
  }
});
observer.observe(document.body, { childList: true, subtree: true });